import type { Diff } from "@tiptap-pro/extension-snapshot-compare";
import { isEqual } from "lodash";

// Snapshot Compare can report Yjs attribute operations even when schema
// normalization produces identical attributes at both document versions.
// For example, inserting a table row can also produce an attribute-only
// block-update for an unchanged table header whose previous and current
// attributes are equal. Rendering it would highlight a node that did not
// change, so discard these diffs regardless of node type.
const isNoopNativeAttributeDiff = (diff: Diff) => {
  if (
    !diff.type.endsWith("-update") ||
    diff.diffContentType !== "attribute-only" ||
    diff.attributes === undefined ||
    diff.previousAttributes === undefined
  ) {
    return false;
  }

  return isEqual(diff.previousAttributes, diff.attributes);
};

export const sanitizeNativeVersionComparisonDiffs = ({
  diffs,
}: {
  diffs: Diff[];
}) => diffs.filter((diff) => !isNoopNativeAttributeDiff(diff));
